import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub';
import { SidebarMenuItem } from './SidebarMenuItem';

const SidebarMenuMain = () => {
  return (
    <>
      <SidebarMenuItemWithSub to='/pages' title='Pages' fontIcon='bi-archive' icon='element-plus'>
        <SidebarMenuItem to='/pages/navbar' title='Navbar' hasBullet={false} />
        <SidebarMenuItem to='/pages/footer' title='Footer' hasBullet={false} />
        <SidebarMenuItemWithSub to='/pages/home' title='Home' hasBullet={false}>
          <SidebarMenuItem to='/pages/home/intro' title='Intro' hasBullet={true} />
          <SidebarMenuItem to='/pages/home/heroCarousel' title='Carousel' hasBullet={true} />
          <SidebarMenuItem to='/pages/home/partners' title='Partners' hasBullet={true} />
          <SidebarMenuItem to='/pages/home/about' title='About' hasBullet={true} />
          <SidebarMenuItem to='/pages/home/client' title='Client' hasBullet={true} />
          <SidebarMenuItem to='/pages/home/community' title='Community' hasBullet={true} />
          <SidebarMenuItem to='/pages/home/news' title='News' hasBullet={true} />
          <SidebarMenuItem to='/pages/home/report' title='Report' hasBullet={true} />
          <SidebarMenuItem to='/pages/home/faq' title='FAQ' hasBullet={true} />
        </SidebarMenuItemWithSub>
        <SidebarMenuItemWithSub to='/pages/about' title='About' hasBullet={false}>
          <SidebarMenuItem to='/pages/about/hero' title='Hero' hasBullet={true} />

          <SidebarMenuItem to='/pages/about/visionTop' title='Vision-top' hasBullet={true} />
          <SidebarMenuItem to='/pages/about/visionBottom' title='Vision-bottom' hasBullet={true} />
          <SidebarMenuItem to='/pages/about/report' title='Report' hasBullet={true} />
          <SidebarMenuItem to='/pages/about/teams' title='Teams' hasBullet={true} />
        </SidebarMenuItemWithSub>

        <SidebarMenuItemWithSub to='/pages/loan' title='Loan' hasBullet={false}>
          <SidebarMenuItem to='/pages/loan/about' title='About' hasBullet={true} />
          <SidebarMenuItem to='/pages/loan/documentation' title='Documentation' hasBullet={true} />
          <SidebarMenuItem to='/pages/loan/terms' title='Terms' hasBullet={true} />
          <SidebarMenuItem to='/pages/loan/process' title='Process' hasBullet={true} />
          <SidebarMenuItem to='/pages/loan/stats' title='Stats' hasBullet={true} />
        </SidebarMenuItemWithSub>

        <SidebarMenuItemWithSub to='/pages/resource' title='Resource' hasBullet={false}>
          <SidebarMenuItem to='/pages/resource/intro' title='Intro' hasBullet={true} />
          <SidebarMenuItem to='/pages/resource/program' title='Programs' hasBullet={true} />
          {/* <SidebarMenuItem to='/pages/resource/partner' title='Partners' hasBullet={true} /> */}

          <SidebarMenuItem to='/pages/resource/tools' title='Tools' hasBullet={true} />
          <SidebarMenuItem to='/pages/resource/stats' title='Stats' hasBullet={true} />
        </SidebarMenuItemWithSub>
        <SidebarMenuItem to='/pages/blog' title='Blog' hasBullet={false}></SidebarMenuItem>
        <SidebarMenuItem
          to='/pages/blogDetail'
          title='Blog Details'
          hasBullet={false}
        ></SidebarMenuItem>
        <SidebarMenuItem to='/pages/faq' title='FAQ' hasBullet={false}></SidebarMenuItem>
        <SidebarMenuItem to='/pages/career' title='Career' hasBullet={false}></SidebarMenuItem>
        <SidebarMenuItemWithSub to='/pages/contact' title='Contact' hasBullet={false}>
          <SidebarMenuItem to='/pages/contact/background' title='Background' hasBullet={true} />
          <SidebarMenuItem to='/pages/contact/form' title='Form' hasBullet={true} />
        </SidebarMenuItemWithSub>
        <SidebarMenuItem to='/pages/business' title='Business' hasBullet={false}></SidebarMenuItem>
        <SidebarMenuItem to='/pages/privacy' title='Privacy Policy' hasBullet={false}></SidebarMenuItem>
      </SidebarMenuItemWithSub>

      <SidebarMenuItemWithSub to='/apps' title='Team' fontIcon='bi-people' icon='people'>
        <SidebarMenuItem to='/apps/admin-users/users' title='Members' hasBullet={true} />
      </SidebarMenuItemWithSub>
    </>
  );
};

export { SidebarMenuMain };
